import { useParams } from 'react-router-dom'

export default function usePagination(first = 10, after = 0) {
  const params = useParams()
  const firstNumber = parseInt(params?.first || first, 10)
  const afterNumber = parseInt(params?.after || after, 10)

  return [firstNumber, afterNumber]
}
